import { Backdrop, CircularProgress, SxProps, Typography } from '@mui/material';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { loadingOverlayAtom } from 'services/loading/atoms';

const backdropStyles: SxProps = {
  color: 'primary.main',
  display: 'flex',
  flexDirection: 'column',
  gap: 2
};

export const LoadingOverlay = () => {
  const { isOpen } = useRecoilValue(loadingOverlayAtom);

  return (
    <Backdrop
      sx={{
        ...backdropStyles,
        zIndex: (theme) => theme.zIndex.drawer + 1
      }}
      open={isOpen}
    >
      <CircularProgress sx={{ color: 'white' }} />
      <Typography color="white" fontWeight="bold">
        Loading
      </Typography>
    </Backdrop>
  );
};
